import { ApiErrorCode } from "@9amhealth/openapi";
import { GLP1_REFILL_QUESTIONNAIRE_ID } from "src/constants/misc";
import { PlanCompleted } from "src/constants/icons";
import { TranslationKey } from "src/types/translationKey";
import { Button } from "@9amhealth/shared";
import { ComponentProps } from "react";
import { APP_CHAT_PATH } from "src/lib/createAppPath";

type ButtonProps = ComponentProps<typeof Button>;

export interface ErrorStateConfig {
  icon?: React.ComponentType<{ size: number }>;
  title: TranslationKey;
  description: TranslationKey;
  buttonText: TranslationKey;
  buttonTheme: ButtonProps["theme"];
  navigateTo: string;
  hideArrow?: ButtonProps["hideArrow"];
  showContactInfo?: boolean;
}

export const SPECIFIC_ERROR_CONFIGS: Record<string, ErrorStateConfig> = {
  [`session_${GLP1_REFILL_QUESTIONNAIRE_ID}_${ApiErrorCode.QUESTIONNAIRE_SESSION_NOT_AVAILABLE}`]:
    {
      icon: PlanCompleted,
      title: "error_code",
      description: "help.messageCareTeam",
      buttonText: "close",
      buttonTheme: "sunrise",
      navigateTo: APP_CHAT_PATH,
      hideArrow: false
    }
};

export const DEFAULT_ERROR_CONFIG: ErrorStateConfig = {
  title: "error_code",
  description: "help.contactUs",
  buttonText: "close",
  buttonTheme: "charcoal",
  navigateTo: APP_CHAT_PATH,
  hideArrow: true,
  showContactInfo: true
};

export const getErrorConfig = (error: string): ErrorStateConfig => {
  if (!error) {
    return DEFAULT_ERROR_CONFIG;
  }

  const specificConfig = SPECIFIC_ERROR_CONFIGS[error] as
    | ErrorStateConfig
    | undefined;

  if (specificConfig) {
    return specificConfig;
  }

  return DEFAULT_ERROR_CONFIG;
};
